import React from 'react'
import Filters from './Filters.js'
import { connect } from 'react-redux'
import { getFabrics } from '../../actions/fabricsActions.js'
import { scrollTo, sendGtag } from '../../utils/utils.js'

const FiltersView = (props) => {
  const { fabrics: fabricsObj, switchCurrentView } = props
  const { filters } = fabricsObj

  const _cancelFilters = () => {
    sendGtag('cancel_mobile_filters_fabrics')
    switchCurrentView()
  }

  const _applyFilters = () => {
    const { dispatch } = props

    sendGtag('apply_mobile_filters_fabrics')
    dispatch(getFabrics(filters, false, 'search'))

    if (window.innerWidth <= 1024) {
      setTimeout(() => {
        scrollTo('cushion-fabric-selector-container', 100)
      }, 100)
    }
    switchCurrentView()
  }

  return (
    <div className="filters-container designer-filters">
      <Filters />
      <div className="buttons-container">
        <div id="cancel-button" className="white-button" onClick={_cancelFilters}>
          CANCEL
        </div>
        <div id="apply-filters-button" className="green-button" onClick={_applyFilters}>
          APPLY FILTERS
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  fabrics: state.fabrics,
})

export default connect(mapStateToProps)(FiltersView)
